export default __webpack_public_path__ + "365211804cd821790aa5f4efa145a189.png";